'use client';

import { c as _c } from "react/compiler-runtime";
import { AutosizeTextarea, Field, FieldError, InputGroup, InputGroupAddon, Spinner } from '@repo/ui/components';
import { useStore } from '@tanstack/react-form';
import { ComponentProps } from 'react';
import { ReadOnlyTooltip, useReadOnly } from '../../components/readonly.tsx';
import { useFieldContext } from '../../lib/form-context.ts';
export const AutoResizeTextarea = t0 => {
  const $ = _c(28);
  let disabled;
  let isPending;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      disabled,
      isPending,
      placeholder: t1,
      rows: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = disabled;
    $[2] = isPending;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    disabled = $[1];
    isPending = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const placeholder = t1 === undefined ? "-" : t1;
  const rows = t2 === undefined ? 1 : t2;
  const field = useFieldContext();
  const errors = useStore(field.store, _temp);
  const isReadOnly = useReadOnly();
  if (isReadOnly) {
    const t3 = field.state.value || "-";
    let t4;
    if ($[6] !== t3) {
      t4 = <ReadOnlyTooltip>{t3}</ReadOnlyTooltip>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  const t3 = isPending || disabled;
  let t4;
  if ($[8] !== field) {
    t4 = e => field.handleChange(e.target.value);
    $[8] = field;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = field.state.value ?? "";
  let t6;
  if ($[10] !== field.handleBlur || $[11] !== placeholder || $[12] !== props || $[13] !== rows || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <AutosizeTextarea className="placeholder:text-foreground focus:placeholder:text-muted-foreground resize-none overflow-hidden border-none p-0 !text-base focus:px-3" data-testid="auto-resize-textarea" disabled={t3} onBlur={field.handleBlur} onChange={t4} placeholder={placeholder} rows={rows} value={t5} {...props} data-sentry-element="AutosizeTextarea" data-sentry-source-file="auto-resize-textarea.tsx" />;
    $[10] = field.handleBlur;
    $[11] = placeholder;
    $[12] = props;
    $[13] = rows;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== isPending) {
    t7 = isPending && <InputGroupAddon align="inline-end"><Spinner className="text-muted-foreground" /></InputGroupAddon>;
    $[18] = isPending;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <div className="relative"><InputGroup variant="ghost" data-sentry-element="InputGroup" data-sentry-source-file="auto-resize-textarea.tsx">{t6}{t7}</InputGroup></div>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== errors) {
    t9 = <FieldError errors={errors} data-sentry-element="FieldError" data-sentry-source-file="auto-resize-textarea.tsx" />;
    $[23] = errors;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <Field className="gap-1" data-sentry-element="Field" data-sentry-component="AutoResizeTextarea" data-sentry-source-file="auto-resize-textarea.tsx">{t8}{t9}</Field>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
function _temp(state) {
  return state.meta.errors;
}